"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const ui_1 = require("@completeanatomy/ui");
const styled_components_1 = __importStar(require("styled-components"));
const constants_1 = require("../../constants");
const SystemsIcons = {
    [constants_1.SystemIdentifier.Skeletal]: ui_1.Icons.Skeletal,
    [constants_1.SystemIdentifier.ConnectiveT]: ui_1.Icons.Connective_T,
    [constants_1.SystemIdentifier.Muscular]: ui_1.Icons.Muscular,
    [constants_1.SystemIdentifier.Arterial]: ui_1.Icons.Arterial,
    [constants_1.SystemIdentifier.Venous]: ui_1.Icons.Venous,
    [constants_1.SystemIdentifier.Lymphatic]: ui_1.Icons.Lymphatic,
    [constants_1.SystemIdentifier.Nervous]: ui_1.Icons.Nervous,
    [constants_1.SystemIdentifier.Respiratory]: ui_1.Icons.Respiratory,
    [constants_1.SystemIdentifier.Digestive]: ui_1.Icons.Digestive,
    [constants_1.SystemIdentifier.Endocrine]: ui_1.Icons.Endocrine,
    [constants_1.SystemIdentifier.Urogenital]: ui_1.Icons.Urogenital,
    [constants_1.SystemIdentifier.Integumentary]: ui_1.Icons.Integumentary,
};
function SystemMenuItem(props) {
    const { isMobile, isExpanded, iconHeight, iconWidth, align, direction, identifier, title, isActive, isSelected, fontSize, onClick, style, tabIndex, } = props;
    const icon = SystemsIcons[identifier] || ui_1.Icons.Microscope;
    const onItemClick = () => {
        onClick(identifier);
    };
    const currentFontSize = fontSize || 12;
    return ((0, jsx_runtime_1.jsxs)(StyledButton, { "$direction": direction, "$align": align, "$isSelected": isSelected, onClick: onItemClick, style: style, tabIndex: tabIndex, "data-e2e": 'SystemMenuItem_StyledButton', children: [(0, jsx_runtime_1.jsx)(ui_1.Icon, { name: icon, selected: isActive, width: iconHeight, height: iconWidth, "data-e2e": 'SystemMenuItem_Icon' }), (0, jsx_runtime_1.jsx)(Title, { "$fontSize": currentFontSize, "$direction": direction, "$isExpanded": isExpanded, "$isMobile": isMobile, "data-e2e": 'SystemMenuItem_Title', children: title })] }));
}
exports.default = SystemMenuItem;
const StyledButton = (0, styled_components_1.default)(ui_1.ToolBarBaseButton) `
  font-weight: 400;
  font-family: Elsevier Sans;
  width: 100%;
  min-width: fit-content;
  border-radius: 4px;
  position: relative;
  display: flex;
  padding: 8px;
  border: none;
  gap: 4px;

  ${({ $direction }) => {
    switch ($direction) {
        case 'top':
            return 'flex-direction: column-reverse;';
        case 'bottom':
            return 'flex-direction: column;';
        case 'right':
            return 'flex-direction: row;';
        default:
            return 'flex-direction: column;';
    }
}}

  justify-content: flex-start;
  align-items: ${({ $align }) => {
    switch ($align) {
        case 'left':
            return 'flex-start;';
        case 'center':
            return 'center;';
        default:
            return 'center';
    }
}};

  &:hover {
    background-color: transparent;
  }

  ${({ $isSelected, theme }) => $isSelected &&
    (0, styled_components_1.css) `
      color: ${theme.grasshopper.menuButtons.active};
    `}
`;
const Title = styled_components_1.default.div `
  margin-bottom: ${({ $isExpanded, $isMobile }) => $isExpanded && !$isMobile ? '10px' : '0'};
  font-size: ${({ $fontSize }) => $fontSize}px;

  margin-left: ${({ $direction }) => ($direction === 'top' ? '4px' : '0')};
  ${({ $direction }) => {
    switch ($direction) {
        case 'top':
            return 'margin-left: 4px;';
        case 'bottom':
            return 'margin-left: 0px;';
        case 'right':
            return 'margin-left: 8px;';
        default:
            return 'margin-left: 4px;';
    }
}}
`;
